module.exports = __webpack_public_path__ + "static/media/2ATH3BK.crop.8337c841.jpg";